
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqmlZXVbj6JqCUSRxtxEDX_j_45QoV6gvvJTGP970Oj0_45McMeta } from "/codebuild/output/src2669176194/src/src/pages/faq.vue?macro=true";
import { default as menu3LZmlLaNL9gGUZLoyZUGkaF6JRc6HTVsvtGWbdPiaAcMeta } from "/codebuild/output/src2669176194/src/src/pages/menu.vue?macro=true";
import { default as indexGsk82xDNph5ARNCwfL8tRTxjEqANvfGjmhuNsmLL7JYMeta } from "/codebuild/output/src2669176194/src/src/pages/index.vue?macro=true";
import { default as contactzll4cxYUEqPHDhgDF4IiMjT5_45fFCgCFQzcqZraMnQtIMeta } from "/codebuild/output/src2669176194/src/src/pages/contact.vue?macro=true";
import { default as tutorialee_pQfpe4UIHix0kbGpgm01dpysPCrNw9rzkmoTHRb0Meta } from "/codebuild/output/src2669176194/src/src/pages/tutorial.vue?macro=true";
import { default as agreementdSVi8LBBdAyr7M9gygULVjFwVvrc_45xvpQi3fpjjww_454Meta } from "/codebuild/output/src2669176194/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass46rQOD_HCzRhddWUzbNgidnSIcGhsy_454bj6zDUw9oaYMeta } from "/codebuild/output/src2669176194/src/src/pages/about-pass.vue?macro=true";
import { default as indexf19nFoXG3pvCVjwiipdVrnkkKmRhz3c_450neCvtMOATsMeta } from "/codebuild/output/src2669176194/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93ClRY_KydE_45OrwhTNn9LCruEJvAXyS6ulUFRB32uwKtQMeta } from "/codebuild/output/src2669176194/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancehkOGYJp1cVkjCSkQBj9RHD31xKoGEkvIMKAMFwrJc10Meta } from "/codebuild/output/src2669176194/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_934KGC8S70Fh48C3DDRUbNzKP1rLgq9wdrTbasDosJfx4Meta } from "/codebuild/output/src2669176194/src/src/pages/notice/[id].vue?macro=true";
import { default as index9B_45xe_w7oSyQJ9L6KyPVKjsSIWBxq19kGT17LXNccsoMeta } from "/codebuild/output/src2669176194/src/src/pages/coupon/index.vue?macro=true";
import { default as indexXs4XizjeOhIh9JPIK0qmQP2W1Fb_45I3YhqaNVSrGbDekMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/index.vue?macro=true";
import { default as indexdv0DdWcwPWmI8Gs033m9HN6Yf6V0W1dKub3wgx6FtxUMeta } from "/codebuild/output/src2669176194/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93khyYj8Fuovt1H0B3mEzKfSfRfjHbFFOPgwOdlxDmNKQMeta } from "/codebuild/output/src2669176194/src/src/pages/parking/[id].vue?macro=true";
import { default as indexcTVAGe1buTLwIfWq5Io4USODoRjW1AJ34Ktj_45lgGXlMMeta } from "/codebuild/output/src2669176194/src/src/pages/history/index.vue?macro=true";
import { default as indexfWOzZi2j13aakkQOYCpJ9mjzKQxKA3fVFvV0oB_4590mQMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/index.vue?macro=true";
import { default as indexgi9fr1_D3fQR8LArUFcxePD6Y_45yk0eFYuj2cmsqlOU0Meta } from "/codebuild/output/src2669176194/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexOvpIl7tSmVFAAbVA0xy7uD_czs0gUge2KeBgR0MCj6wMeta } from "/codebuild/output/src2669176194/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviLH7yCXuON4u2Rz0DE2bnoVNPEit6GySOqgU3d_Akn_gMeta } from "/codebuild/output/src2669176194/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editU0uDCLBvld_iv7rWFJycp6wqMTv2dRkrXomFvgrlK58Meta } from "/codebuild/output/src2669176194/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementhdpA3b0j8q6Ql3_CwfVKHDRfr8ZbnLBZxCcP7xoaGa0Meta } from "/codebuild/output/src2669176194/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexjYwPnutH7ZZKWSM_45_45QXxtqkPbLdP7TKqdeHR6J60KDwMeta } from "/codebuild/output/src2669176194/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dM1s0bvn8kYNLuqLPKbbt9pJHVZ39jNo2Ndp3lfqEgkYMeta } from "/codebuild/output/src2669176194/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmwXiV6tBWEXsGHj_45k4nKMEN0OgsJARNxmPfvXH0j4YHsMeta } from "/codebuild/output/src2669176194/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexm25V9HXMcipR6WxKSzhe41VXRTD_45vBS5OZI2dtx5unUMeta } from "/codebuild/output/src2669176194/src/src/pages/card/create/index.vue?macro=true";
import { default as index0vIvpwHjiC5vimqseryKuJnWhLTC64olZRYdDQWSLVQMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmzxmNeZ1oyYobsO50pcgZaXx_45Qq0ghrcylhrYX_450ZNiYMeta } from "/codebuild/output/src2669176194/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmtVUv3zoYbrvOotxQB71HWjKwtAEK26sB2xEsGbK1Hy8Meta } from "/codebuild/output/src2669176194/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeORAOLEzMloR6uU_7JKNFaWUtervAtBvkm1UC_j4p5ewMeta } from "/codebuild/output/src2669176194/src/src/pages/membership/complete.vue?macro=true";
import { default as registerT0l5UN21X6YOr5v84hK0_45mPmDS2B6h0A7uJh68xwm9oMeta } from "/codebuild/output/src2669176194/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93Znt9ltkD8Od_45Vo2Co6squdoDUMt4FvFTcUDI3BJv6poMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmTFy3_456s0ZhhVJ9muhvhYVs3HueSyHrvmTZpD8It4mV4Meta } from "/codebuild/output/src2669176194/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93HG79WCwQvxvQBd3_45d3QEH9UcPYfrE2X9pjYDp25hKFsMeta } from "/codebuild/output/src2669176194/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index33_GMpxY7Xp6XN1TLDLP_45cjMnudx_45leVpoFIS_L_VBIMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45coden3SK1MQT631BljMKFIXOFIAAa6Q_4507AXHycz_dZo1aYMeta } from "/codebuild/output/src2669176194/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code_R3A_EoB7YMG0PU8BdJhtS7k4T9cLJqZ_eeN0nG8QYQMeta } from "/codebuild/output/src2669176194/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completede37bsDz9bznrqvYP3mDWlpuefB2prDcn_rnAuwK5KcMeta } from "/codebuild/output/src2669176194/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerzKWYlemEGhcbqTcMwKcUxKJZildbUjFXtHBwRZqBJzIMeta } from "/codebuild/output/src2669176194/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeAMG9WcizbeoirJWaBn23PMSAE93CV819l1uQrCL6yEgMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexS_45bVs8rkYsWTVnrQefzN4m0Ms0LLw4Tr01XTxsPUmBIMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmRZ3iXbA9RgUbqtXccUYnKEQq0vabm2EVE5emv5CwBoAMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeEfk6IWcIKqJ9f1Q8RuNWmQxJvFwx9K_45wcrxQEby_vucMeta } from "/codebuild/output/src2669176194/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index_KJFG3E2cARvERiVFephBcu4DyU2_45bCUTfaSMsOZLMcMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93yccmfP1l1B2Anjg7YGN_45nG5jCGAMpJxmF_45Qol_ChCnMMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completepAdeQkiwkM_45n9W2X0nujB4hWPTQhgRw7kqh0S3s3_BYMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasxxkLRdbvxn7I0m9H7AFn6Ln4Pg0R_45LPd_95IhIcTwWgMeta } from "/codebuild/output/src2669176194/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleZN0py2EnabJcyqL8gCj0fkU2f8TwTS1XxWZEOJEcewsMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailzAL0eeXMVRPYi6FBsAQcM6S1ccm3dCO5zf_mL9uw2t8Meta } from "/codebuild/output/src2669176194/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmyGaGYlZAjqGGeQwXRm945DzcNFerR0i63X2sWNrbgGIMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentfx1nwqbPM0OYYp_snf2UXvB8IOXm8xzfGw4OI0ZeONcMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmJkc5LVhsfcthEdzRhwRhsshdYVdjhWRw9zlECCzGhyEMeta } from "/codebuild/output/src2669176194/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatesmfi76UhkV_45YFvBTYLbUtnt_45eGQVMXdarGVeGVphTYEMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete7n6SftVsCEqP4YlrmoP87RJRs6EXWdKHh4sJgkHrldgMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeNNNt3Oo2JJhaQCKD5iVMYxqXynUN2YhCvSu0a1Cn0KwMeta } from "/codebuild/output/src2669176194/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordqk54XZpaKuk5IRqKI9IUvXUsLc5t2R_IcK0n8UlqQ00Meta } from "/codebuild/output/src2669176194/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias8rJkYKXagZUkaxM3_45OBqkO_45ciNS08zG5OcJuzq6A5CMMeta } from "/codebuild/output/src2669176194/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerkW5y180L3lBO8BR9giUI_45uGakBOmlXSqH_45bq3bDw_8cMeta } from "/codebuild/output/src2669176194/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeq7hdNxhlMNm9_45r3T2s_YPdpZgXo1IOotXPnjL_fBug4Meta } from "/codebuild/output/src2669176194/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexHeh5PI_9JaEzh6afy9QAeHAtXPwKiqko4jvvJrBm6W4Meta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexZIh_45Fw0D4ZKJArHPYYqOImfGSFRaZKgwxNem5x6WzTMMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index2kTlo88DmQo7CPS_wfFCHycDVjuGxPv0JN28D2HamhAMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexrxikEWSJmITcQn0sCkXn09ExBYL1u1njWIzFzrnXVHsMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatekVSvnHM6JYqnGHL_D_45tRQhDP14H7_45XT_459DM98WVDXC0Meta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete_cc29qfhckVtLWrP0zGFpAwpI1wyU5D48vE8E6N3QywMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm_m0rkeDJeE2rn6mInVKX6OwC23N9mVXEK7C0l1X6wGIMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexgAdAFx8x_xDRDyfZLPUafjV7BtVrdOiAveeTNicnUL4Meta } from "/codebuild/output/src2669176194/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeLKTsHz0O5hfrnjAmp9KfLvqwh1WI_45V6ky1ot4w4l9KUMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update6q45fWls8BRYcTyXtXYZNSgBYzHX9DhkmbSf6XPtKu0Meta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexIeN6Fmih_45DbRcxdUwM2d4lUGEIeBTfn_45aeRpf0JXcd8Meta } from "/codebuild/output/src2669176194/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index22UZcNvXMcUALau5hM8oo75pgtCTCTm_TgdB4IpQhWAMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete1hT_45SkZgNsxKexjfF7sWsIorS_45Z8jrBhPvhq0B9_E6MMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexPwacZx6VuE2lheAoChT9Mlv9l5_RAwGjGMz9rSbD3TwMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeLaHZPrUidIM8dEcKhcQ_vsZxqttl_puIUQ5P7NZ76DcMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexBN_jeKENPmIu2jhlRtT55ICJ3pOiMCs0mO7CZkYrYPkMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexOusLJOzyK27e9uap5B9CLZNZCNfXJGffQXPteqy50EkMeta } from "/codebuild/output/src2669176194/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexWj8zu1VpJTt7jWDq0o0bGutJj9oGFFRuYZ_MOXZQjB8Meta } from "/codebuild/output/src2669176194/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatezFcJLeeVIC1oK_PyTit2gqcqt2ZYnc46qeYbjwcdU5wMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmneANm0lYOuTkS79qPpytVxsguhCrC7fc9tM5Ly75GRAMeta } from "/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu3LZmlLaNL9gGUZLoyZUGkaF6JRc6HTVsvtGWbdPiaAcMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexGsk82xDNph5ARNCwfL8tRTxjEqANvfGjmhuNsmLL7JYMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index9B_45xe_w7oSyQJ9L6KyPVKjsSIWBxq19kGT17LXNccsoMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexcTVAGe1buTLwIfWq5Io4USODoRjW1AJ34Ktj_45lgGXlMMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexgi9fr1_D3fQR8LArUFcxePD6Y_45yk0eFYuj2cmsqlOU0Meta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexOvpIl7tSmVFAAbVA0xy7uD_czs0gUge2KeBgR0MCj6wMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexm25V9HXMcipR6WxKSzhe41VXRTD_45vBS5OZI2dtx5unUMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmzxmNeZ1oyYobsO50pcgZaXx_45Qq0ghrcylhrYX_450ZNiYMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmtVUv3zoYbrvOotxQB71HWjKwtAEK26sB2xEsGbK1Hy8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeORAOLEzMloR6uU_7JKNFaWUtervAtBvkm1UC_j4p5ewMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerT0l5UN21X6YOr5v84hK0_45mPmDS2B6h0A7uJh68xwm9oMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmTFy3_456s0ZhhVJ9muhvhYVs3HueSyHrvmTZpD8It4mV4Meta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45coden3SK1MQT631BljMKFIXOFIAAa6Q_4507AXHycz_dZo1aYMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code_R3A_EoB7YMG0PU8BdJhtS7k4T9cLJqZ_eeN0nG8QYQMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completede37bsDz9bznrqvYP3mDWlpuefB2prDcn_rnAuwK5KcMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerzKWYlemEGhcbqTcMwKcUxKJZildbUjFXtHBwRZqBJzIMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmRZ3iXbA9RgUbqtXccUYnKEQq0vabm2EVE5emv5CwBoAMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeEfk6IWcIKqJ9f1Q8RuNWmQxJvFwx9K_45wcrxQEby_vucMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index_KJFG3E2cARvERiVFephBcu4DyU2_45bCUTfaSMsOZLMcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completepAdeQkiwkM_45n9W2X0nujB4hWPTQhgRw7kqh0S3s3_BYMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleZN0py2EnabJcyqL8gCj0fkU2f8TwTS1XxWZEOJEcewsMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailzAL0eeXMVRPYi6FBsAQcM6S1ccm3dCO5zf_mL9uw2t8Meta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmyGaGYlZAjqGGeQwXRm945DzcNFerR0i63X2sWNrbgGIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentfx1nwqbPM0OYYp_snf2UXvB8IOXm8xzfGw4OI0ZeONcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmJkc5LVhsfcthEdzRhwRhsshdYVdjhWRw9zlECCzGhyEMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete7n6SftVsCEqP4YlrmoP87RJRs6EXWdKHh4sJgkHrldgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeNNNt3Oo2JJhaQCKD5iVMYxqXynUN2YhCvSu0a1Cn0KwMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordqk54XZpaKuk5IRqKI9IUvXUsLc5t2R_IcK0n8UlqQ00Meta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerkW5y180L3lBO8BR9giUI_45uGakBOmlXSqH_45bq3bDw_8cMeta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeq7hdNxhlMNm9_45r3T2s_YPdpZgXo1IOotXPnjL_fBug4Meta || {},
    component: () => import("/codebuild/output/src2669176194/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2669176194/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]